// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2-ykr","spin":"Spinner_spin__1Ehln","container":"Spinner_container__OwHDj"};